export default "__VITE_ASSET__Ci$q0V_3__"